export default {
    startPageLinks: false,
    startPage: false,
    loginWithoutRegister: false,
    logo: {
        isEnabled: true,
        locales: {
            ru: {
                src: require(`../resources/images/inkk-logo_ru.png`),
                alt: 'Инконсалт',
            },
            en: {
                src: require(`../resources/images/inkk-logo_en.png`),
                alt: 'Inconsult',
            },
        },
        style: { maxHeight: 65 },
        withText: false,
        mdLogo: false,
    },
    customBackground: {
        isEnabled: true,
    },
    helpIcon: false,
    notificationIcon: true,
    phoneNumber: false,
    startPageDefaultText: false,
    esiaLogin: false,
    showCreateRequestButton: false,
    showRequestsLamp: false,
    showCampaignPeriod: true,
    loginDialogClose: false,
    loginDialogAlert: true,
    yaMetrika: true,
    modularNavigation: false,
    email: true,
    changeLanguage: true,
};
